import { apiFactory } from '@app/client';
import { trackEvent, trackPage } from '@app/client/resources/segment';
import config from '@app/config';

import packageInfo from '../../package.json';

function track_pixel(event: string, properties: Record<string, string | number | null> = {}) {
    if (config.fbPixelId) {
        if (event === 'page_view') {
            window.fbq('track', 'PageView', properties);
        } else {
            window.fbq('trackCustom', event, properties);
        }
    }
}

export function track(event: string, properties: Record<string, string | number | null> = {}) {
    apiFactory().call(trackEvent, {
        value: {
            event,
            properties: {
                ...properties,
            },
            timestamp: new Date(),
            type: 'track',
            context: {
                userAgent: navigator.userAgent,
                app: { version: packageInfo.version },
            },
        },
    });

    track_pixel(event, properties);
}

export async function track_page_view(page: string) {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {
        utm_campaign: urlParams.get('utm_campaign') || null,
        utm_source: urlParams.get('utm_source') || null,
        utm_medium: urlParams.get('utm_medium') || null,
    };

    await apiFactory().call(trackPage, {
        value: {
            event: 'page_view',
            options: {
                integrations: {
                    'Customer.io': false,
                },
            },
            page,
            properties: {
                ...utmParams,
                path: page,
            },
            type: 'page',
            timestamp: new Date(),
        },
    });

    track('page_view', {
        route: page,
    });
}

export function get_anonymous_id() {
    const cookies = window.document.cookie && window.document.cookie.split('; ');
    const cookie = cookies && cookies.find((row) => row.startsWith('ajs_anonymous_id'));
    const ajs_anonymous_id = cookie && cookie.split('=')[1];

    return ajs_anonymous_id && ajs_anonymous_id.replace(/%22/g, '');
}
